import {
	ProductKeys,
	type ProductKeys1P,
	type ProductKeys3P,
} from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createBooleanFilter } from '../../../../filters/boolean-filter';
import type { BooleanFilterMonad } from '../../../../filters/boolean-filter/types';
import type { CloudConfig } from '../../../../filters/types';

const productKeys1P: ProductKeys1P[] = [ProductKeys.Confluence];

const originalProducts3P: ProductKeys3P[] = [];

const products3PFromConfig: ProductKeys3P[] = getProducts3PFromConfigForFilter('verified');

const getProducts3P = () => {
	// fg('rovo-full-page-search-3p-static-config') => false
	return false ? products3PFromConfig : originalProducts3P;
};

export const filter: {
    customValueFields: string[] | undefined; getInitialState: (config: CloudConfig) => BooleanFilterMonad<"verified">; id: "verified"; isCompatible: (filterState?: {
        id: string;
    } | undefined) => filterState is Readonly<{
        alwaysVisible: boolean;
        hasSelection: boolean;
        id: "verified";
        products: ProductKeys[];
        queryParams: {
            key: string;
        };
        type: "boolean";
        universal: boolean;
        value: boolean;
    }>; isSupportCustomValue: boolean; products: ProductKeys[]; queryParams: {
        key: string;
    }; type: "boolean"; universal: boolean; withState: (state: unknown, config: CloudConfig) => BooleanFilterMonad<"verified">;
} = createBooleanFilter({
	id: 'verified',
	queryParams: { key: 'verified' },
	products: [...productKeys1P, ...getProducts3P()],
	alwaysVisible: true,
	universal: false,
});
